module.exports = __webpack_public_path__ + "static/media/ipad.2a52c8d8.png";